/**
 * Created by ChrisMuto on 6/28/17.
 */
import * as audienceActionTypes from "./types";
import * as moment from "moment";

function audiences(
    state = { loading: false, error: null, lastLoaded: null },
    action
) {
    switch (action.type) {
        case audienceActionTypes.REQUEST_AUDIENCES:
            return {
                loading: true,
                error: null,
                lastLoaded: null
            };
        case audienceActionTypes.RECEIVE_AUDIENCES:
            return {
                loading: false,
                error: null,
                lastLoaded: moment()
            };

        case audienceActionTypes.RECEIVE_AUCIENCES_ERROR: {
            return {
                loading: false,
                error: action.error,
                lastLoaded: null
            };
        }

        default:
            return state;
    }
}

export default audiences;



// WEBPACK FOOTER //
// ./src/modules/audiences/reducers.js